<template>
  <!--标题-->
  <div class="fill_form mt20 m0 mb30 clearfix">
    <h3 class="form_title clearfix"><span>| </span>老办法计发比例
    </h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th v-for="tableTittle in tableTittles1">{{tableTittle}}</th>
        </tr>
        <tr v-for="(item,index) in oldMethodCalculatingProportion">
          <td>{{item.desc}}</td>
          <td>{{item.retirement_proportion>0?item.retirement_proportion:''}}</td>
          <td>{{item.resign_proportion>0?item.resign_proportion:''}}</td>
        </tr>
      </table>
    </div>
    <h3 class="form_title clearfix"><span>| </span>个人养老金计发月数表（2025年1月1日之前）</h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th v-for="tableTittle in tableTittles2">{{tableTittle}}</th>
        </tr>
        <tr v-for="(items,index) in monthNumber">
          <template v-for="(item,num) in items">
            <td>{{item[0]}}</td>
            <td>{{item[1]}}</td>
          </template>
        </tr>
      </table>
    </div>

    <h3 class="form_title clearfix"><span>| </span>个人养老金计发月数表（2025年1月1日之后）</h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th>退休年龄：年 \ 月</th>
<!--          <th v-for="tableTittle in tableTittles2">{{tableTittle}}</th>-->
          <th v-for="inx in [0,1,2,3,4,5,6,7,8,9,10,11]">{{inx}}</th>
        </tr>
        <tr v-for="(items,index) in monthNumberWhenDelay">
          <th>{{index}}</th>
          <template v-for="(item,num) in items">
            <td>{{item}}</td>
          </template>
        </tr>
      </table>
    </div>

    <h3 class="form_title clearfix"><span>| </span>新老办法对比限高享受比例
    </h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th v-for="tableTittle in tableTittles3">{{tableTittle}}</th>
        </tr>
        <tr v-for="(items,index) in highestProportion">
        <template v-for="(item,num) in items">
          <td>{{item[0]}}</td>
          <td>{{item[1]}}</td>
        </template>
        </tr>
      </table>
    </div>
    <h3 class="form_title clearfix"><span>| </span>退休人员生活补贴标准
    </h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th v-for="tableTittle in tableTittles4">{{tableTittle}}</th>
        </tr>
        <tr v-for="(items,index) in subsidyAmount">
          <template v-for="(item,num) in items">
            <td>{{item[0]}}</td>
            <td>{{item[1]}}</td>
          </template>
        </tr>
      </table>
    </div>
    <h3 class="form_title clearfix"><span>| </span>事业单位专业技术人员职务职级对应表
    </h3>
    <div class="table_outer_box">
      <table class="table">
        <tr>
          <th class="slant" colspan="2">
            <div class="div1"><span>专业技术系列</span></div>
            <div class="div2"><span>对应职务</span></div>
            <span class="th_span">职务/级别</span>
          </th>
          <th>工程技术<br/>工艺美术</th>
          <th>经济<br/>会计<br/>统计</th>
        </tr>
        <tr v-for="(items,index) in rankCorrespondence">
          <td>
            <p v-for="item in items[1]">{{item}}</p>
          </td>
          <td>
            <p v-for="item in items[2]">{{item}}</p>
          </td>
          <td><p v-for="item in items[3]">{{item}}</p></td>
          <td><p v-for="item in items[4]">{{item}}</p></td>
        </tr>
      </table>
    </div>
  </div>


  <!-- 标题 end-->
</template>
<script>
  import axios from 'axios'
  export default{
    name:'configInfo',
    data () {
      return {
        tableTittles1:['累计缴费年限','退休','退职'],
        tableTittles2:['退休年龄','计发月数','退休年龄','计发月数','退休年龄','计发月数'],
        tableTittles3:['退休日期','享受比例','退休日期','享受比例'],
        tableTittles4:['职级','生活补贴标准（元/人·月）','职级','生活补贴标准（元/人·月）'],
        highestProportion:[],
        monthNumber:[],
        monthNumberWhenDelay:[],
        rankCorrespondence:{},
        subsidyAmount:[],
        oldMethodCalculatingProportion:[]
      }
    },
    mounted:function(){
      var that = this;
      function getOldMethodCalculatingProportion() {
        return axios.get('/config/getOldMethodCalculatingProportion');
      }
      function getHighestProportion() {
        return axios.get('/config/getHighestProportion');
      }
      function getMonthNumber() {
        return axios.get('/config/getMonthNumber');
      }
       function getMonthNumberWhenDelay() {
        return axios.get('/config/getMonthNumberWhenDelay');
      }
      function getPositionRankCorrespondence() {
        return axios.get('/config/getPositionRankCorrespondence');
      }
      function getSubsidyAmount() {
        return axios.get('/config/getSubsidyAmount');
      }
      axios.all([
        getOldMethodCalculatingProportion(),
        getHighestProportion(),
        getMonthNumber(),
        getMonthNumberWhenDelay(),
        getPositionRankCorrespondence(),
        getSubsidyAmount()
      ])
        .then(axios.spread(function(
          oldMethodCalculatingProportion,
          highestProportion,
          monthNumber,
          monthNumberWhenDelay,
          rankCorrespondence,
          subsidyAmount
        ){
          if(oldMethodCalculatingProportion.data.code == 22000){
            that.oldMethodCalculatingProportion=oldMethodCalculatingProportion.data.result
          }else if(oldMethodCalculatingProportion.data.code==50001){
            window.location.href='/#/login';
          }

          // 2025年之前的规则
          if(monthNumber.data.code == 22000){
            var entries = Object.entries(monthNumber.data.result);
            for (var i=0; i<entries.length; i+3){
              that.monthNumber.push(entries.splice(i,(i+3)))
            }
          }else if(monthNumber.data.code==50001){
            window.location.href='/#/login';
          }

          // 2025年之后的规则，
          if(monthNumberWhenDelay.data.code == 22000){
            that.monthNumberWhenDelay = monthNumberWhenDelay.data.result
          }else if(monthNumberWhenDelay.data.code==50001){
            window.location.href='/#/login';
          }

          if(highestProportion.data.code == 22000){
            var entries1 = Object.entries(highestProportion.data.result);
            for (var i=0; i<entries1.length; i+2){
              that.highestProportion.push(entries1.splice(i,(i+2)))
            }
          }else if(highestProportion.data.code==50001){
            window.location.href='/#/login';
          }

          if(subsidyAmount.data.code == 22000){
            var entries1 = Object.entries(subsidyAmount.data.result);
            for (var i=0; i<entries1.length; i+2){
              that.subsidyAmount.push(entries1.splice(i,(i+2)))
            }
          }else if(subsidyAmount.data.code==50001){
            window.location.href='/#/login';
          }

          if(rankCorrespondence.data.code == 22000){
              that.rankCorrespondence=rankCorrespondence.data.result
          }else if(rankCorrespondence.data.code==50001){
            window.location.href='/#/login';
          }


        }));

    },
    methods:{

    }
  }
</script>
<style lang="less">
  .table_outer_box{
    margin-bottom: 30px;
  }
  td,th{
    border-right:1px solid #e1e7f6;
    text-align: center;
    padding-right: 10px !important;
  }
  .table{
    border-right: none;
  }
  .slant{
    width: 25px !important;
    position: relative;
    overflow:hidden;
    .th_span{
      position: absolute;
      bottom:10px;
      left:20px;
    }
    div{
      width:110%;
      height:100%;
      text-align: center;
      line-height: 100%;
      position:absolute;
      bottom:0;
      right: 0;
      border-bottom:1px solid #e1e7f6;
      transform-origin: right bottom;
      span{
        position: absolute;
      }
    }
    .div1 {
      -webkit-transform: rotate(30deg);
      -moz-transform: rotate(30deg);
      -ms-transform: rotate(30deg);
      -o-transform: rotate(30deg);
      transform: rotate(30deg);
      span{
        bottom:39px;
        right: 26px;
        transform-origin: right bottom;
        -webkit-transform: rotate(-30deg);
        -moz-transform: rotate(-30deg);
        -ms-transform: rotate(-30deg);
        -o-transform: rotate(-30deg);
        transform: rotate(-30deg);
      }
    }
    .div2{
      -webkit-transform: rotate(15deg);
      -moz-transform: rotate(15deg);
      -ms-transform: rotate(15deg);
      -o-transform: rotate(15deg);
      transform: rotate(15deg);
      span{
        bottom:15px;
        right: 150px;
        transform-origin: right bottom;
        -webkit-transform: rotate(-15deg);
        -moz-transform: rotate(-15deg);
        -ms-transform: rotate(-15deg);
        -o-transform: rotate(-15deg);
        transform: rotate(-15deg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pension_params/fixedInfo.vue